module.exports = __webpack_public_path__ + "static/media/parking-car.172d7d98.svg";